module.exports = __webpack_public_path__ + "img/qr.77b11a05.png";